import { Temporal } from '@js-temporal/polyfill'

export function isDefined<T>(value: T | undefined): value is T {
  return value !== undefined && value !== null
}

export function isEmailValid(email: string): boolean {
  if (!email.trim()) return true
  const emailRegex: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return emailRegex.test(email)
}

export function toPossessive(name: string): string {
  return name.endsWith('s') ? `${name}'` : `${name}'s`
}

export function toSentenceCase(str: string): string {
  if (!str) return ''

  return str.slice(0, 1).toLocaleUpperCase().concat(str.slice(1))
}

export function toHeadlineCase(str: string, separator: string = ' '): string {
  if (!str) return ''

  return str
    ?.split(separator)
    .map((w) => toSentenceCase(w))
    .filter((w) => w !== '')
    .join(' ')
}

export function getContributionURL(schoolSlug: string, parentSlug: string, requestType: string = 'parent'): string {
  const tributaryURL = import.meta.env.VITE_TRIBUTARY_URL
  return `${tributaryURL}/${schoolSlug}?parent_slug=${parentSlug}&request_type=${requestType}`
}

export function getSignInURL(schoolSlug?: string): string {
  const baseURL = import.meta.env.VITE_PROLOGUE_URL

  //TODO: this is used to search for a bug.
  const contributionURL =
    schoolSlug !== undefined && schoolSlug !== 'undefined' ? `${baseURL}/${schoolSlug}/signin` : baseURL
  return contributionURL
}

export function getRegistrationURL(schoolSlug?: string): string {
  const baseURL = import.meta.env.VITE_PROLOGUE_URL

  return schoolSlug ? `${baseURL}/${schoolSlug}` : baseURL
}

export function calculateDaysRemaining(disableDate: string | null): number {
  if (!disableDate) return 0

  const dateWithoutTime = disableDate.substring(0, 10)

  const today = Temporal.Now.plainDateISO()
  const disable = Temporal.PlainDate.from(dateWithoutTime)

  const duration = today.until(disable, { largestUnit: 'days' })

  return Math.max(0, Math.floor(duration.days))
}
